import React from 'react';
import { MetricGrid } from '@/shared/components/patterns';

const metricIconKeys = {
  total: 'metrics.requests',
  highPriority: 'metrics.pending',
  totalEstimatedValue: 'metrics.currency',
  pipelineVolume: 'metrics.currency',
  estimatedVolume: 'metrics.currency',
  activeStages: 'metrics.inProgress',
  totalValue: 'metrics.currency',
  volume: 'metrics.currency',
  assignedCount: 'metrics.requests',
  settled: 'metrics.completed',
  toSettle: 'metrics.pending',
  thisWeek: 'metrics.month',
  waiting: 'metrics.pending',
  overdue: 'metrics.overdue',
  unavailable: 'metrics.document',
};

function formatStatValue(item, stats) {
  const value = stats[item.key] ?? 0;
  if (item.format === 'currency') {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(value);
  }
  return `${item.prefix || ''}${value}${item.suffix || ''}`;
}

const DealsStatsGrid = ({ items = [], stats = {}, activeMetric, onMetricClick }) => {
  const metrics = items.map((item) => ({
    id: item.key,
    label: item.title,
    value: formatStatValue(item, stats),
    iconKey: metricIconKeys[item.key] || 'metrics.document',
    tone: item.tone || 'neutral',
    active: activeMetric === item.key,
    onClick: onMetricClick ? () => onMetricClick(item.key) : undefined,
  }));

  return <MetricGrid metrics={metrics} />;
};

export default DealsStatsGrid;
